const data = {
	"body": "<path fill=\"currentColor\" d=\"M220 40v144a4 4 0 0 1-8 0V44H72a4 4 0 0 1 0-8h144a4 4 0 0 1 4 4Zm-32 32v144a4 4 0 0 1-4 4H40a4 4 0 0 1-4-4V72a4 4 0 0 1 4-4h144a4 4 0 0 1 4 4Zm-8 4H44v136h136Z\"/>",
	"width": 256,
	"height": 256
};
exports.__esModule = true;
exports.default = data;
